//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import axios from "axios";
import AQModal from "@/components/Generics/AQModal/AQModal.vue";
import AQCard from "@/components/Generics/AQCard/AQCard.vue";
import AQList from "@/components/Generics/AQList/AQList.vue";
import { zenIds } from "./routesIds";

export default {
    name: "HelpCenter",
    components: {
        AQModal,
        AQCard,
        AQList
    },
    props: {
        atId: {
            type: String,
            default: ""
        }
    },
    data() {
        return {
            modalValue: true,
            currentArticles: [],
            currentModule: null

        };
    },
    computed: {
        setAtId() {
            const param = this.$route && this.$route.name ? this.$route.name : "";
            return `help-center-${param || this.atId || ""}`;
        }
    },
    mounted() {
        if (this.$route) {
            this.currentModule = zenIds.find(el => (el.route === this.$route.path) || (el.name === this.$route.name));
        }
        const payload = {
            sectionId: this.currentModule.id
        };
        this.externalEndpoint(payload);
    },
    methods: {
        actionsDlg() {
            this.$emit("closeActive");
        },
        externalEndpoint(data) {
            const authBase64 = btoa("admin@aurachain.ch/token:tOWUANwSmosfPy91YRHKlzCdBunxd32EBE5QcuxD");
            let typeOfCategory = "categories";
            if (this.currentModule.section) {
                typeOfCategory = "sections";
            }
            const config = {
                method: "GET",
                url: `https://help-aurachain.zendesk.com/api/v2/help_center/en-us/${typeOfCategory}/${data.sectionId}/articles`,
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Basic ${authBase64}`
                }
            };
            return new Promise((resolve, reject) => {
                /* eslint-disable-next-line */
                axios(config)
                    .then(rsp => {
                        this.currentArticles = rsp.data.articles;
                        if (this.currentModule.fromBuilding && this.currentModule.extraData) {
                            this.currentArticles.push(this.currentModule.extraData);
                        }
                        resolve(rsp);
                    })
                    .catch(err => { reject(err); });
            });
        },
        redirectTo(item) {
            window.open(item.html_url, "_blank");
        },
        redirectToArticles(academy) {
            if (academy) {
                window.open("https://academy.aurachain.ch/", "_blank");
            } else {
                window.open("https://help.aurachain.ch/hc/en-us", "_blank");
            }
        }
    }
};
